type TimeEntryWithId = {
  id: unknown
  status?: unknown
  [key: string]: unknown
}

export const markTimeEntryAsReleased = <T extends TimeEntryWithId>(
  entries: T[],
  timeentryId: unknown
): T[] =>
  entries.map(entry =>
    String(entry.id) === String(timeentryId)
      ? { ...entry, status: 'released' }
      : entry
  )
